export interface SummaryProps {
  modules:
    | {
        _type: string
        [key: string]: any
        body: {
          children: {
            [key: string]: any
            text: string
          }[]
        }[]
      }[]
    | string
    | undefined
  limit: number
  testID?: string
}

export default function Summary({ modules, limit, testID }: SummaryProps) {
  const createSummaryFromModules = (blocks: any) => {
    return (
      blocks
        .map((block: any) => {
          if (
            block._type === 'leadParagraph' ||
            block._type === 'numberBlock' ||
            block._type === 'textBlock'
          ) {
            return (block?.body || [])?.map((child: any) => {
              if (child.children)
                return child.children
                  .map((child: any) => {
                    return child.text
                  })
                  .join('')
            })
          }
          if (block._type === 'block') {
            return block.children
              .map((child: any) => {
                return child.text
              })
              .join('')
          }
        })
        // join the paragraphs leaving split by two linebreaks
        .join('\n\n') as string
    )
  }

  const getSubstring = (summary: string, reverseCheck = false): string => {
    const sentenceTerminators = ['.', '!', '?', ';', ':', '‽']
    let substring = summary.substring(0, limit)

    // Check if the substring ends with a sentence terminator
    const endsWithTerminator = sentenceTerminators.includes(
      substring[substring.length - 1]
    )

    if (reverseCheck && !endsWithTerminator) {
      // Search for the previous sentence terminator from the current limit position
      for (let i = limit - 1; i >= 0; i--) {
        if (sentenceTerminators.includes(summary[i])) {
          limit = i + 1 // Update the limit to include the sentence terminator
          substring = summary.substring(0, limit)
          break
        }
      }
    } else if (!endsWithTerminator) {
      // If reverseCheck is false, then perform the original forward check
      while (!sentenceTerminators.includes(substring[substring.length - 1])) {
        limit++
        substring = summary.substring(0, limit)
      }
    }
    // Replace all sentence terminators with an ellipsis
    return `${substring.replace(/[.?!;:‽\s]*$/, '')}...`
  }

  const articleSummary =
    typeof modules === 'string'
      ? getSubstring(modules, true)
      : modules && modules.length > 0
        ? getSubstring(createSummaryFromModules(modules), true)
        : ''

  return testID ? (
    <div data-testid={testID}>{articleSummary}</div>
  ) : (
    <>{articleSummary}</>
  )
}
